import { Facets, SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SetFacetsMutation implements SearchMutation {

  mutations = {
    [SEARCH_MUTATIONS_KEYS.setFacets]: (searchState: SearchState, facets: Facets) => {
      searchState.facets = facets;
    }
  };
}
